const comparisonCard = (editor) => {

    editor.BlockManager.add('comparisonCard', {
        category: 'Built In Components',
        label: 'Comparison Card',
        attributes: {},
        content: `
        <div class="card-body col-10 m-auto">
          <div class="row rounded-3 shadow">
            <div class="col-md-8 py-2" >
              <div class="mx-4 my-4">
                <p class="h3 mb-3"><strong>Lifetime Membership</strong></p>
                <p class="text-muted">Lorem ipsum dolor sit amet consectetur adipisicing elit. Cupiditate quae
                  deserunt excepturi nihil nobis. Hic dolores architecto quod dicta, iusto odio, sit quae cum,
                  quos
                  alias eveniet corrupti ab pariatur.</p>
                <p class="text-uppercase text-primary mb-0 new-section" > what’s included
                  <span class="line-pricing"></span></p>
        
                <div class="row">
                  <div class="col-md-6">
                    <ol class="list-unstyled mb-0 pt-0 pb-0">
                      <p class="my-3 fw-bold text-muted text-center">
                      </p>
                      <li class="mb-3">
                        <i class="bi-check text-success me-3"></i><small>Lorem Ipsum</small>
                      </li>
                      <li class="mb-3">
                        <i class="bi-check text-success me-3"></i><small>Lorem Ipsum</small>
                      </li>
                    </ol>
                  </div>
                  <div class="col-md-6">
                    <ol class="list-unstyled mb-0 pt-0 pb-0">
                      <p class="my-3 fw-bold text-muted text-center">
                      </p>
                      <li class="mb-3">
                        <i class="bi-check text-success me-3"></i><small>Lorem Ipsum</small>
                      </li>
                      <li class="mb-3">
                        <i class="bi-check text-success me-3"></i><small>Lorem Ipsum</small>
                      </li>
                    </ol>
                  </div>
                </div>
              </div>
            </div>
            <div class="col-md-4 text-center d-flex justify-content-center align-items-center bg-light">
              <div class=" pt-4 me-4">
                <p class="h5">Pay once, own it forever</p>
                <p class="h2 fw-bold text-black">$199</p>
                <p class="text-decoration-underline text-black-50 " >Learn more about our
                  company</p>
                <a href="#" class="btn btn-dark d-block mb-2 mt-3 text-capitalize">Get Access</a>
                <p class="fw-bold mt-3" >Get a free sample <span
                    class="text-muted">(20MB)</span></p>
              </div>
        
            </div>
          </div>
        </div>
        `
    })
};

export default comparisonCard;